import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';

export interface ICarouselProps {
  className?: string;
  elementPerView?: number;
  rows?: number | 'auto';
  icon?: any;
  breakpoints?: any;
  list?: any[];
  onSlideClick?: Function;
  lazyLoad?: boolean;
  onLoadedList?: (a?: any[]) => unknown;
  title?: string;
}

export const Carousel = memo((p: ICarouselProps) => {
  const breakpoints = {
    ...(p.breakpoints?.hasOwnProperty(1024)
      ? p.breakpoints
      : {
          1024: {
            slidesPerView: 3.5,
            spaceBetween: 4,
          },
        }),
    ...(p.breakpoints?.hasOwnProperty(768)
      ? p.breakpoints
      : {
          768: {
            slidesPerView: 3.4,
            spaceBetween: 4,
          },
        }),
    ...(p.breakpoints?.hasOwnProperty(320)
      ? p.breakpoints
      : {
          320: {
            freeMode: false,
            slidesPerView: 2.6,
            spaceBetween: 4,
          },
        }),
  };
  const { t } = useTranslation();

  return (
    <section className="CarouselComponent" style={{ width: '100%' }}>
      <h3 className="text-left fontSize130">{p.title}</h3>
      <Swiper
        spaceBetween={8}
        slidesPerView={3.5}
        breakpoints={breakpoints}
      >
        {p.list.map((element, idx) => (
          <SwiperSlide onClick={(e) => p.onSlideClick && p.onSlideClick(e, element)} key={idx}>
            <div style={{ padding: '0 0 20px' }}>
              <Link
                to={element.link}
              >
                <img
                  src={element.picture.image}
                  alt={element.picture.title}
                  style={{ borderRadius: 6, width: '100%' }}
                />
                <button className="basicButton playNow" style={{ width: '100%' }}>
                  {t('summary.play-now')}
                </button>
              </Link>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
});
